import PreviewSection from '../../PreviewSection'
import {escapeHtmlSymbols} from '../../../../atUtils'
import {ReportGroupingLevel} from '../../../constants'

export default function BillingSummaryHTMLPreviewGroupingSection() {}

BillingSummaryHTMLPreviewGroupingSection.prototype = new PreviewSection();

BillingSummaryHTMLPreviewGroupingSection.prototype.init = function(groupingLevelsArray, hasNonGroupingLevel, columnsStrategy, timeFormat, reportAuthorizationInfo)
{
    PreviewSection.prototype.init.call( this );
    this.groupingLevelsArray = groupingLevelsArray;
    this.columnsStrategy = columnsStrategy;
    this.timeFormat = timeFormat;
    this.hasNonGroupingLevel = hasNonGroupingLevel;
    this.allUsersAvailable = reportAuthorizationInfo.allUsersAvailable
    this.othersStarted = false

    return this
}

BillingSummaryHTMLPreviewGroupingSection.prototype.levelClasses = ["firstLevel", "secondLevel","thirdLevel"];
BillingSummaryHTMLPreviewGroupingSection.prototype.groupingClasses= ["firstGrouping", "secondGrouping","thirdGrouping"];

BillingSummaryHTMLPreviewGroupingSection.prototype.addRows = function( tBody )
{
    this.addRowWithMainCell( tBody, this.message("report.billing_summary.total_sc"), "", "totalValue");

    const length = this.groupingLevelsArray.length
    let levels
    if( length === 1 )
        levels = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, this._getLastLevelNumber(0)]

    if( length === 2 )
    {
        if (ReportPreviewUtils.isLevelCanBeAddedMoreThanOnce(this.groupingLevelsArray[1], [this.groupingLevelsArray[0]]))
            levels = [0, 1, 1, this._getLastLevelNumber(1), 0, 1, 1, this._getLastLevelNumber(1), this._getLastLevelNumber(0), 1, 1, this._getLastLevelNumber(1)]
        else
            levels = [0, 1, 0, 1, 0, 1, 0, 1, 0, 1, 0, 1];
    }

    if( length > 2 )
    {
        if (ReportPreviewUtils.isLevelCanBeAddedMoreThanOnce(this.groupingLevelsArray[2], this.groupingLevelsArray.slice(0, 2))
            && ReportPreviewUtils.isLevelCanBeAddedMoreThanOnce(this.groupingLevelsArray[1], [this.groupingLevelsArray[0]])
        )
            levels = [0, 1, 2, 2, this._getLastLevelNumber(1), 2, 2, this._getLastLevelNumber(0), 1, 2, 2]
        else
            levels = [0, 1, 2, 0, 1, 2, 0, 1, 2, 0, 1, 2];
    }

    for (let i = 0; i < levels.length; ++i)
        this.addGroupingRow(tBody, levels[i]);

};

BillingSummaryHTMLPreviewGroupingSection.prototype._getLastLevelNumber = function(defaultNumber) {
    if (this.groupingLevelsArray[defaultNumber] === ReportGroupingLevel.USER && !this.allUsersAvailable) return 3
    return defaultNumber
}

BillingSummaryHTMLPreviewGroupingSection.prototype.addRowWithMainCell = function( tBody, escapedText, rowClassName, className )
{
    var row = this.createRow(rowClassName);
    row.appendChild( ReportPreviewUtils.createCell( escapedText, className ) );
    this.addDataCells(row);
    this.addRow(tBody, row);
};

BillingSummaryHTMLPreviewGroupingSection.prototype.addDataCells = function( row )
{
    this.columnsStrategy.addColumnValueCells(row);
};

BillingSummaryHTMLPreviewGroupingSection.prototype.addGroupingRow = function( tBody, index )
{
    let levelName
    if (index === 3) {
        levelName = this.message("report.common.others")
        index = this.groupingLevelsArray.indexOf(ReportGroupingLevel.USER)
        this.othersStarted = true
    } else {
        if (index === 0) this.othersStarted = false
        levelName = this._getLevelPreviewName(this.groupingLevelsArray[index])
    }

    const grIndex = (index === this.groupingLevelsArray.length - 1) && this.hasNonGroupingLevel ? 2 : index

    !!levelName && this.addRowWithMainCell( tBody, levelName, this.groupingClasses[grIndex], this.levelClasses[index] );
}

// returns escaped level preview name
BillingSummaryHTMLPreviewGroupingSection.prototype._getLevelPreviewName = function(groupingType) {
    switch (groupingType) {
        case ReportGroupingLevel.TT_COMMENTS:
            return this._getCommentsCombinedLevelPreviewName()
        case ReportGroupingLevel.TASK_AND_TT_COMMENTS:
            return this._getCommentsCombinedLevelPreviewName(ReportGroupingLevel.TASK)
        case ReportGroupingLevel.PROJECT_AND_TT_COMMENTS:
            return this._getCommentsCombinedLevelPreviewName(ReportGroupingLevel.PROJECT)
        case ReportGroupingLevel.CUSTOMER_AND_TT_COMMENTS:
            return this._getCommentsCombinedLevelPreviewName(ReportGroupingLevel.CUSTOMER)

        default:
            return escapeHtmlSymbols(ReportPreviewUtils.getLevelPreviewName(groupingType))
    }
}

BillingSummaryHTMLPreviewGroupingSection.prototype._getCommentsCombinedLevelPreviewName = function(firstPartGroupingType) {
    let firstPart = firstPartGroupingType ? escapeHtmlSymbols(ReportPreviewUtils.getLevelPreviewName(firstPartGroupingType)) : ""

    if (this.othersStarted) {
        return firstPart
    } else {
        if (!!firstPart) firstPart += ": "
        return firstPart + "<i>" + ReportPreviewUtils.getLevelPreviewName(ReportGroupingLevel.TT_COMMENTS) + "</i>"
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/billingsummary/BillingSummaryHTMLPreviewGroupingSection.js